import { render, staticRenderFns } from "./OrderReceiveUpdate.vue?vue&type=template&id=72065978&"
import script from "./OrderReceiveUpdate.vue?vue&type=script&lang=js&"
export * from "./OrderReceiveUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports